import { createGridLayout, createGridItem } from "../../../../store/global/gridlayout";

export const contactImportExportGrid = createGridLayout({
    layout: [
        createGridItem({
            x: 0,
            y: 0,
            w: 60,
            h: 10,
            i: 'import',
        }),
        createGridItem({
            x: 10,
            y: 0,
            w: 60,
            h: 10,
            i: 'export',
        }),
        createGridItem({
            x: 20,
            y: 0,
            w: 60,
            h: 10,
            i: 'merge_contact',
        }),
    ]
});